export const translations = {
  ur: {
    // Store Branding
    storeName: 'ہمالین پنسار سٹور',
    dawakhanaName: 'دواخانہ طب پاکستانی',
    hakimName: 'حکیم مولانا سید عبدالوہاب شاہ شیرازی',
    storeSubtitle: 'خالص جڑی بوٹیاں اور مستند طبِ پاکستانی ادویات کا بااعتماد مرکز',
    announcement: 'پورے پاکستان میں کیش آن ڈلیوری کی سہولت | 5,000 روپے سے زائد پر مفت ڈلیوری!',
    
    // Navigation
    home: 'صفحہ اول',
    shop: 'سٹور / تمام ادویات',
    categories: 'اقسام ادویات',
    tibbiGuide: 'طبی رہنمائی و مزاج',
    aboutHakim: 'ہمارے بارے میں',
    contact: 'رابطہ و مطب',
    adminLogin: 'ایڈمن لاگ ان',
    searchPlaceholder: 'ادویات، جڑی بوٹیاں، یا امراض تلاش کریں (مثلاً کلونجی، گیس، معدہ)...',
    
    // Buttons & Badges
    addToCart: 'شاپنگ کارٹ میں شامل کریں',
    buyNowWhatsapp: 'واٹس ایپ پر فوری آرڈر',
    orderOnWhatsapp: 'واٹس ایپ آرڈر بھیجیں',
    viewDetails: 'تفصیلات و طریقہ استعمال',
    cart: 'شاپنگ کارٹ',
    checkout: 'چیک آؤٹ / آرڈر کنفرم کریں',
    inStock: 'دستیاب ہے',
    outOfStock: 'سٹاک ختم',
    pureHerbal: '100% خالص قدرتی',
    bestSeller: 'سب سے زیادہ فروخت',
    freeDeliveryBadge: 'مفت ڈلیوری دستیاب',
    
    // Product Details
    mizaj: 'مزاج',
    benefits: 'افعال و خواص (فوائد)',
    usage: 'طریقہ استعمال و مقدار خوراک',
    precautions: 'احتیاطی تدابیر و پرہیز',
    selectWeight: 'وزن / مقدار منتخب کریں:',
    price: 'قیمت:',
    reviews: 'ریویوز',
    relatedProducts: 'ملتی جلتی دیگر ادویات',
    
    // Filters
    filterByMizaj: 'مزاج کے مطابق تلاش:',
    filterByAilment: 'امراض و تکالیف کے لحاظ سے:',
    allCategories: 'تمام کیٹیگریز',
    priceRange: 'قیمت کی حد:',
    inStockOnly: 'صرف دستیاب اشیاء دکھائیں',
    resetFilters: 'تمام فلٹرز ختم کریں',
    noProductsFound: 'آپ کی تلاش کے مطابق کوئی پراڈکٹ نہیں ملی۔ براہ کرم دوسرے الفاظ آزمائیں۔',
    showingResults: 'دستیاب نتائج:',
    
    // Cart
    cartEmpty: 'آپ کا شاپنگ کارٹ خالی ہے۔',
    subtotal: 'اشیاء کی رقم:',
    deliveryFee: 'ڈلیوری چارجز:',
    freeDelivery: 'مفت ڈلیوری',
    freeDeliveryNotice: 'روپے کی مزید خریداری پر مفت ڈلیوری حاصل کریں!',
    total: 'کل واجب الادا رقم:',
    emptyCart: 'کارٹ خالی کریں',
    continueShopping: 'مزید خریداری جاری رکھیں',
    proceedToCheckout: 'چیک آؤٹ مکمل کریں',
    
    // Checkout
    checkoutTitle: 'آرڈر کی تفصیلات اور ترسیل',
    fullName: 'گاہک کا پورا نام *',
    phone: 'موبائل فون نمبر *',
    city: 'شہر / ضلع *',
    address: 'مکمل گلی، محلہ، مکان نمبر و پتہ *',
    notes: 'کوئی خاص ہدایت یا طبی نوٹ (اختیاری)',
    paymentMethod: 'طریقہ ادائیگی منتخب کریں:',
    cod: 'کیش آن ڈلیوری (سامان ملنے پر رقم دیں)',
    onlinePayment: 'ایزی پیسہ / آن لائن بینک ٹرانسفر (یا UBL کیو آر کوڈ)',
    placeOrder: 'آرڈر کنفرم کریں (Cash on Delivery)',
    placeOrderWhatsApp: 'آرڈر کنفرم کریں',
    
    // Trust Badges
    badge1Title: 'خالص و اصلی جڑی بوٹیاں',
    badge1Desc: 'ہمالین اور مستند پہاڑی و میدانی نباتات',
    badge2Title: 'پورے پاکستان میں ڈلیوری',
    badge2Desc: '2 تا 4 دن میں محفوظ ترسیل آپ کی دہلیز پر',
    badge3Title: 'مستند طبی رہنمائی',
    badge3Desc: 'مطب پر حکیم صاحب سے بالمشافہ طبی مشورہ و تشخیص',
    badge4Title: 'کیش آن ڈلیوری (COD)',
    badge4Desc: 'سامان دیکھ کر رقم ادا کرنے کا مکمل اطمینان',

    // Admin
    adminTitle: 'ایڈمن ڈیش بورڈ',
    manageProducts: 'مصنوعات کی مینجمنٹ',
    manageOrders: 'آرڈرز کی فہرست',
    storeSettings: 'سٹور سیٹنگز',
    addProduct: 'نئی دوا / پروڈکٹ شامل کریں',
    editProduct: 'پروڈکٹ میں ترمیم',
    deleteProduct: 'ڈیلیٹ کریں',
    orderStatus: 'آرڈر کا اسٹیٹس',
    customer: 'خریدار',
    date: 'تاریخ',
    actions: 'ایکشن',
    saveChanges: 'تبدیلیاں محفوظ کریں',
    cancel: 'منسوخ کریں',
    logout: 'لاگ آؤٹ'
  },
  en: {
    // Store Branding
    storeName: 'Himalayan Pansar Store',
    dawakhanaName: 'Dawakhana Tib-e-Pakistani',
    hakimName: 'Hakim Maulana Syed Abdul Wahab Shah Shirazi',
    storeSubtitle: 'Trusted Destination for 100% Pure Herbs & Tibb-e-Pakistani Formulations',
    announcement: 'Nationwide Cash on Delivery | Free Delivery on Orders Above Rs. 5,000!',
    
    // Navigation
    home: 'Home',
    shop: 'Shop All',
    categories: 'Categories',
    tibbiGuide: 'Tibbi Guide & Mizaj',
    aboutHakim: 'About Us',
    contact: 'Contact & Location',
    adminLogin: 'Admin Login',
    searchPlaceholder: 'Search herbs, medicines, ailments (e.g. Kalonji, digestion, pain)...',
    
    // Buttons & Badges
    addToCart: 'Add to Cart',
    buyNowWhatsapp: 'Quick WhatsApp Order',
    orderOnWhatsapp: 'Send Order via WhatsApp',
    viewDetails: 'View Details & Usage',
    cart: 'Shopping Cart',
    checkout: 'Checkout / Confirm Order',
    inStock: 'In Stock',
    outOfStock: 'Out of Stock',
    pureHerbal: '100% Natural Organic',
    bestSeller: 'Bestseller',
    freeDeliveryBadge: 'Free Delivery Eligible',
    
    // Product Details
    mizaj: 'Temperament (Mizaj)',
    benefits: 'Actions & Therapeutic Benefits',
    usage: 'Dosage & Directions for Use',
    precautions: 'Precautions & Contraindications',
    selectWeight: 'Select Weight / Packing:',
    price: 'Price:',
    reviews: 'Reviews',
    relatedProducts: 'Related Herbal Formulations',
    
    // Filters
    filterByMizaj: 'Filter by Mizaj (Temperament):',
    filterByAilment: 'Filter by Health Concern:',
    allCategories: 'All Categories',
    priceRange: 'Price Range:',
    inStockOnly: 'In-Stock Only',
    resetFilters: 'Reset All Filters',
    noProductsFound: 'No products matched your criteria. Please try another search.',
    showingResults: 'Results found:',
    
    // Cart
    cartEmpty: 'Your cart is empty.',
    subtotal: 'Items Subtotal:',
    deliveryFee: 'Delivery Fee:',
    freeDelivery: 'FREE Delivery',
    freeDeliveryNotice: 'Add more to your cart to get FREE delivery!',
    total: 'Total Amount Payable:',
    emptyCart: 'Clear Cart',
    continueShopping: 'Continue Shopping',
    proceedToCheckout: 'Proceed to Checkout',
    
    // Checkout
    checkoutTitle: 'Shipping Details & Checkout',
    fullName: 'Full Name *',
    phone: 'Mobile Phone Number *',
    city: 'City / District *',
    address: 'Complete Street Address, House / Shop No. *',
    notes: 'Special Instructions / Medical Note (Optional)',
    paymentMethod: 'Select Payment Method:',
    cod: 'Cash on Delivery (Pay upon delivery)',
    onlinePayment: 'EasyPaisa / Bank Transfer / UBL QR',
    placeOrder: 'Confirm Order (Cash on Delivery)',
    placeOrderWhatsApp: 'Confirm Order',
    
    // Trust Badges
    badge1Title: '100% Pure Potent Herbs',
    badge1Desc: 'Authentic Himalayan & traditional botanical harvests',
    badge2Title: 'Nationwide Delivery',
    badge2Desc: 'Safe delivery to your doorstep within 2-4 days',
    badge3Title: 'Medical Consultation',
    badge3Desc: 'In-person diagnosis & consultation with Hakim Sahib at the clinic',
    badge4Title: 'Cash on Delivery (COD)',
    badge4Desc: 'Inspect your parcel before making cash payment',

    // Admin
    adminTitle: 'Admin Dashboard',
    manageProducts: 'Manage Products',
    manageOrders: 'Manage Orders',
    storeSettings: 'Store Settings',
    addProduct: 'Add New Product',
    editProduct: 'Edit Product',
    deleteProduct: 'Delete',
    orderStatus: 'Order Status',
    customer: 'Customer',
    date: 'Date',
    actions: 'Actions',
    saveChanges: 'Save Changes',
    cancel: 'Cancel',
    logout: 'Logout'
  }
};
